import React from "react";
import { SpinningLoader } from "risa-oasis-ui_v2";
import Pagination from "../pagination/pagination";
import { CellData } from "./table";
import TableBody from "./tableBody";

interface TableWithPaginationProps {
  tableName: string;
  sortedTableHeaders: any[];
  computedCellData: CellData[][];
  tableDataToRender: any[];
  tableWidth: number;
  onSortTableData: (key: string, subKey?: string, type?: string) => void;
  onRowClick: (tableData: any[], rowIndex: number, className: string) => void;
  onStatusClick?: (data: any) => void;
  onDeleteIconClick?: (data: any) => void;
  onEditIconClick?: (data: any) => void;
  hidePagination?: boolean;
  count?: number;
  itemsPerPage?: number;
  pagesPerView?: number;
  handlePageChange: (startIndex: number, endIndex: number, data: any[]) => void;
  triggerHandlePageChange: number;
  paginationData: React.ReactNode;
  showInLineLoader?: boolean;
  toggleCheckboxSelection?: (id: string) => void;
  onDownloadIconClick?: (filePath: string, fileName?: string) => void;
  startIndex?: number;
  isPreviousButtonDisabled?: boolean;
  expandableRowContent?: (rowData: any, rowIndex: number) => React.ReactNode;
  onRowExpansionChangeFromTableBody?: (expanded: boolean, id: string) => void;
  isExpandableRowTable?: boolean;
  onButtonWithThreeDotsOptionClick?: (optionId: string, rowId: string) => void;
  scrollableWidth?: number;
  onActionOnInputClick?: (data: string, id: string, fieldId?: string) => void;
  onInputChange?: (data: string, id: string, fieldId?: string) => void;
  onTagOptionClick?: (
    menuId: string,
    dataId?: string,
    fieldId?: string,
  ) => void;
  onTagDropDownSelectChange?: (
    value: string,
    dataId?: string,
    fieldId?: string,
  ) => void;
  onCellValueChange?: (rowData: any, fieldKey: string, newValue: any) => void;
  onChangeEmit?: (data: {
    name: string;
    required: boolean;
    value: boolean;
  }) => void;
  onClickableTextWithDisabledStatusClick?: (data: any) => void;
  onComplete?: () => void;
}

const TableWithPagination: React.FC<TableWithPaginationProps> = (props) => {
  return (
    <>
      <div
        className={`table ${props.scrollableWidth ? "scrollable-table" : ""}`}
        style={{
          width: props.scrollableWidth ? `${props.scrollableWidth}%` : "100%",
          overflowX: "hidden",
        }}
      >
        <table key={props.tableName}>
          <TableBody
            computedCellData={props.computedCellData}
            tableDataToRender={props.tableDataToRender}
            tableWidth={props.tableWidth}
            onRowClick={props.onRowClick}
            onStatusClick={props.onStatusClick}
            onDeleteIconClick={props.onDeleteIconClick}
            onEditIconClick={props.onEditIconClick}
            onClickableTextWithDisabledStatusClick={
              props.onClickableTextWithDisabledStatusClick
            }
            onComplete={props.onComplete}
            toggleCheckboxSelection={props.toggleCheckboxSelection}
            onDownloadIconClick={props.onDownloadIconClick}
            startIndex={props.startIndex}
            expandableRowContent={props.expandableRowContent}
            onRowExpansionChangeFromTableBody={
              props.onRowExpansionChangeFromTableBody
            }
            sortedTableHeaders={props.sortedTableHeaders}
            isExpandableRowTable={props.isExpandableRowTable}
            onButtonWithThreeDotsOptionClick={
              props.onButtonWithThreeDotsOptionClick
            }
            scrollableWidth={props.scrollableWidth ?? 100}
            onActionOnInputClick={props.onActionOnInputClick}
            onInputChange={props.onInputChange}
            onTagOptionClick={props.onTagOptionClick}
            onTagDropDownSelectChange={props.onTagDropDownSelectChange}
            onCellValueChange={props.onCellValueChange}
            onChangeEmit={props.onChangeEmit}
          />
        </table>
      </div>
      {props.showInLineLoader && (
        <div className="table-loader mb-4 mr-4 flex items-center justify-end gap-2 text-small font-regular">
          <SpinningLoader />
          Loading Data ...
        </div>
      )}
      {!props.hidePagination && (
        <div
          className="table-pagination mt-4"
          style={{
            width: props.scrollableWidth ? `${props.scrollableWidth}%` : "100%",
          }}
        >
          {(props.count ?? 0) > 0 && (
            <>
              <Pagination
                itemsCount={props.count ?? 0}
                itemsPerPage={props.itemsPerPage ?? 0}
                pagesPerView={props.pagesPerView ?? 0}
                sendStartAndEndIndex={props.handlePageChange}
                triggerHandlePageChange={props.triggerHandlePageChange}
                tableName={props.tableName}
                isPreviousButtonDisabled={props.isPreviousButtonDisabled}
              />
              <div className="pagination-details">{props.paginationData}</div>
            </>
          )}
        </div>
      )}
    </>
  );
};

export default TableWithPagination;
